import { Typography } from "@mui/material";
import styles from "./ActionCard.module.css";

type ActionCardProps = {
	title: string;
	description: string;
	rightButton: React.ReactNode;
};

export default function ActionCard({ title, description, rightButton }: ActionCardProps) {
	return (
		<div className={styles.card}>
			<div>
				<div>
					<Typography className={styles.title}>{title}</Typography>
					<Typography className={styles.description}>{description}</Typography>
				</div>
				{rightButton}
			</div>
		</div>
	);
}
